// @flow

import * as React from 'react'
import { Button } from 'semantic-ui-react'
import { connect, type Connector } from 'react-redux'
import { setReportStartDate } from '../store/reports'
import moment from 'moment'
// $FlowFixMe
import 'moment/locale/it'

import type { ReduxState, Dispatch } from '../store'

type OwnProps = {||}

type MappedProps = {|
  selectedValue: string,
  selectedLabel: string,
  values: Array<{| startDate: string, name: string |}>,
  backButtonDisabled: boolean,
  forwardButtonDisabled: boolean,
|}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps): MappedProps => {
  let pagerValues = []

  let dates = Object.keys(state.reports.ui.data ? state.reports.ui.data : {}).map(d => parseInt(d, 10))
  let firstDate = false //moment('1979-01-01')
  let lastDate = false //moment('1979-01-01')
  if (dates.length) {
    firstDate = moment(Math.min(...dates).toString(), 'YYYYMMDD')
    lastDate = moment(Math.max(...dates).toString(), 'YYYYMMDD')

    if (state.reports.ui.chartSampling === 'DAILY') {
      // Prepare data for DAILY report
      while (lastDate.isAfter(firstDate) || firstDate.format('M') === lastDate.format('M')) {
        let name = firstDate.format('MMMM YYYY')
        name = name[0].toUpperCase() + name.slice(1)
        pagerValues.push({
          name,
          startDate: firstDate.startOf('month').format('YYYYMMDD'),
        })
        firstDate.add(1, 'month')
      }
    } else if (state.reports.ui.chartSampling === 'WEEKLY') {
      // Prepare data for WEEKLY report
      firstDate.startOf('quarter')
      while (lastDate.isAfter(firstDate) || firstDate.format('YYYYMMDD') === lastDate.format('YYYYMMDD')) {
        pagerValues.push({
          name: `${firstDate.format('Q')}° Trimestre ${moment(firstDate).format('YYYY')}`,
          startDate: firstDate.format('YYYYMMDD'),
        })
        firstDate.endOf('quarter').add(1, 'day')
      }
    } else if (state.reports.ui.chartSampling === 'MONTHLY') {
      // Prepare data for MONTHLY report
      while (lastDate.isAfter(firstDate) || firstDate.format('YYYY') === lastDate.format('YYYY')) {
        pagerValues.push({
          name: firstDate.format('YYYY'),
          startDate: firstDate.startOf('year').format('YYYYMMDD'),
        })
        firstDate.add(1, 'year')
      }
    }
  }

  let selectedValue = state.reports.ui.reportStartDate
  let selectedObj = pagerValues.find(r => r.startDate === selectedValue) || { name: '', startDate: '' }
  let selectedLabel = selectedObj.name ? selectedObj.name : ''

  return {
    selectedValue,
    values: pagerValues,
    selectedLabel,
    forwardButtonDisabled: pagerValues.length ? selectedValue === pagerValues[pagerValues.length - 1].startDate : true,
    backButtonDisabled: pagerValues.length ? selectedValue === pagerValues[0].startDate : true,
  }
}

type Props = { dispatch: Dispatch } & OwnProps & MappedProps
class ReportPager extends React.Component<Props> {
  static defaultProps = {}

  componentWillReceiveProps(newProps) {
    if (newProps.values.length && JSON.stringify(this.props.values) !== JSON.stringify(newProps.values)) {
      let d = newProps.values[newProps.values.length - 1].startDate
      this.props.dispatch(setReportStartDate(d))
    }
  }

  onChange = (value: string) => {
    let selectedIndex = this.props.values.findIndex(r => r.startDate === this.props.selectedValue)
    if (value === 'back' && selectedIndex > 0) {
      this.props.dispatch(setReportStartDate(this.props.values[selectedIndex - 1].startDate))
    } else if (value === 'forward' && selectedIndex < this.props.values.length - 1) {
      this.props.dispatch(setReportStartDate(this.props.values[selectedIndex + 1].startDate))
    }
  }

  render() {
    return (
      <Button.Group size="small">
        <Button
          primary
          icon="left chevron"
          disabled={this.props.backButtonDisabled}
          onClick={() => this.onChange('back')}
        />
        <Button content={this.props.selectedLabel} disabled={true} style={{ color: 'black', minWidth: '20ex' }} />
        <Button
          primary
          icon="right chevron"
          disabled={this.props.forwardButtonDisabled}
          onClick={() => this.onChange('forward')}
        />
      </Button.Group>
    )
  }
}

const connector: Connector<OwnProps, MappedProps> = connect(mapStateToProps, null)
export default connector(ReportPager)



// WEBPACK FOOTER //
// ./src/reports/calendar-report-pager.js